import {Button} from "antd";
import {Link} from "react-router-dom";
import React from "react";

const ToHomeButton = () => {
    return (
        <Link to='/'>
            <Button type="primary">Back Home</Button>
        </Link>
    )
};

export default ToHomeButton;